angular.module('com.vmware.vsphere.client.vm').constant('migrationTypeConstants',
      {
         MIGRATE_RESOURCE_ONLY: 'changeResourceOnly',
         MIGRATE_STORAGE_ONLY: 'changeStorageOnly',
         MIGRATE_RESOURCE_AND_STORAGE: 'changeComputeResourceAndStorage'
      }
);
